import { type HttpResponseResolver, HttpResponse } from 'msw';
import { parse } from 'qs-esm';
import { type GeoData } from '#src/types';
import { geoValues } from './__mocks__/geo-values';

export const mockGeoEndpoint: HttpResponseResolver = ({ request }) => {
  const url = new URL(request.url);
  const parsedParams = parse(url.search, {
    ignoreQueryPrefix: true,
  });
  const selectedYears = (
    (parsedParams.selectedYears as string[]) ?? []
  ).map((y) => Number(y));

  const geoData: GeoData = selectedYears.map((year) => ({
    year,
    geoData: geoValues,
  }));

  return HttpResponse.json({
    geoData,
  });
};
